import { render, staticRenderFns } from "./alarmForProperty.vue?vue&type=template&id=4642b4a6&scoped=true"
import script from "./alarmForProperty.vue?vue&type=script&lang=js"
export * from "./alarmForProperty.vue?vue&type=script&lang=js"
import style0 from "./alarmForProperty.vue?vue&type=style&index=0&id=4642b4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642b4a6",
  null
  
)

export default component.exports